/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProfileDirectorySearchRequest} from '@cash-web/protos/squareup/cash/customersearch/api/ProfileDirectorySearch.pb'
import {ProfileDirectorySearchResponse} from '@cash-web/protos/squareup/cash/customersearch/api/ProfileDirectorySearch.pb'


export const profileDirectorySearch = (request: ProfileDirectorySearchRequest, options?: CashRequestOptions) => post<ProfileDirectorySearchRequest, ProfileDirectorySearchResponse>("/2.0/cash/profile-directory-search", request, {...options, rejectOnError: true })